<template>
  <div class="c-uploader">
    <div
      class="preview-container"
      v-for="(item, index) in value"
      :key="item+index"
    >
      <button
        class="delete-button"
        @click="onDeleteClick(index)"
      >
        <img
          src="../views/autoStudy/images/delete.png"
          class="delete-icon"
          alt=""
        >
      </button>
      <img
        :src="item"
        alt=""
      >
    </div>
    <div
      class="input-container"
      v-if="value.length<maxCount"
    >
      <input
        type="file"
        accept="image/jpeg,image/jpg,image/png,image/svg"
        @change="onFileChange"
      >
      <p class="lg">
        +
      </p>
      <p>上传图片</p>
    </div>
    <p
      class="t--grey"
      v-if="value.length<maxCount"
    >
      最多上传{{ maxCount }}张图片
    </p>
  </div>
</template>

<script>
import { uploadFile } from '@/api/feedback';
import { toast } from '@/pages/amt-web/utils/dd';

export default {
  name: 'SUploader',
  props: {
    maxCount: {
      type: Number,
      default: 3,
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    onDeleteClick(index) {
      const filteredValue = this.value.filter((value, i) => i !== index);
      this.$emit('input', filteredValue);
    },
    // 展示 base64 for 测试
    readFile(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          resolve(e.target.result);
        };
        reader.onerror = (e) => {
          reject(e);
        };
        reader.readAsDataURL(file);
      });
    },
    uploadFile(file) {
      this.loading = true;
      const form = new FormData();
      form.append('image', file, file.name);
      return uploadFile(form).finally(() => {
        this.loading = false;
      });
    },
    onFileChange(e) {
      this.uploadFile(e.target.files[0]).then((res) => {
        if (res.code === 200) {
          toast('上传成功');
          this.$emit('input', [...this.value, res.data.picture_url]);
        } else {
          toast('图片上传失败');
        }
      }).catch(() => {
        toast('图片上传失败');
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.c-uploader {
  display: flex;
  position: relative;
  padding-bottom: 18px;
  .t--grey {
    color: rgba(155, 155, 155, 1);
    font-size: 26px;
    position: absolute;
    right: 0;
    bottom: -26px;
  }
  .input-container, .preview-container {
    width: 200px;
    height: 200px;
    background: #F6F6F6;
    border-radius: 20px;
    border: 2PX dashed #979797;
    position: relative;
    box-sizing: border-box;
    color: rgba(155, 155, 155, 1);
    font-size: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    & + .input-container {
      margin-left: 40px;
    }
    .lg {
      font-size: 50px;
    }
    p + p {
      margin-top: 26px 0;
    }
    input {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      opacity: 0;
    }
  }
  .preview-container {
    border: 0;
    & + .preview-container {
      margin-left: 40px;
    }
    img {
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      object-fit: cover;
    }
    .delete-icon {
      position: absolute;
      top: -22px;
      right: -22px;
      width: 44px;
      height: 44px;
      left: auto;
    }
  }
}
</style>
